import { nextTick } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import { AuthLocalStorageKeys } from '@store/auth';
export default defineNuxtPlugin(({ vueApp }) => {
    const { isWebApp } = useDevice();
    vueApp.use(
        createGtm({
            id: 'GTM-5WVWHDP',
            vueRouter: useRouter(),
            defer: true,
            source: '/api/gtm',
            debug: false,
            trackOnNextTick: true,
        })
    );

    useScriptTag(
        '/js/posthog.js',
        () => {
            window.posthog.init(
                'phc_6I9FuXTI7Hb789HOwDkGyeWf2TS4ExjOpc6PTZocxFm',
                {
                    api_host: 'https://ph.mrbilit.ir',
                    capture_pageview: false,
                    autocapture: false,
                    loaded: () => {
                        const layoutStore = useLayoutStore();
                        vueApp.config.globalProperties.__posthog =
                            window.posthog;
                        const credentials = JSON.parse(
                            localStorage.getItem(
                                AuthLocalStorageKeys.credentials
                            ) || '[]'
                        );
                        const index = +(
                            localStorage.getItem(
                                AuthLocalStorageKeys.selectedCredentialIndex
                            ) || '0'
                        );
                        window.posthog.identify(
                            localStorage.loginUuid ||
                                credentials[index]?.uuid ||
                                localStorage.localUuid,
                            { environment: useRunEnv() }
                        );
                        layoutStore.isPosthogReady = true;
                        useRouter().afterEach((to: any) => {
                            nextTick(() => {
                                /* Note:
                                 * this might also be a good place to call posthog.register(...) in order to update your properties
                                 * on each page view
                                 */
                                window.posthog.capture('$pageview', {
                                    $current_url: to.fullPath,
                                    isWebApp: isWebApp.value,
                                });
                            });
                        });
                    }, // If you can already identify your user
                }
            );
        },
        { defer: true, async: true }
    );

    useRouter().afterEach(to => {
        nextTick(() => {
            if (isWebApp.value) {
                window.WebAppWebEngageChannel?.postMessage(
                    JSON.stringify({
                        type: 'screen',
                        to: to.name,
                        fullPath: to.fullPath,
                    })
                );
            } else {
                window.webengage?.onReady(() => {
                    window.webengage?.reload();
                    window.webengage?.screen(to.name?.toString() || '', {
                        fullPath: to.fullPath,
                    });
                });
            }
        });
    });
});
